export const UnsupportedDepositAddressChainIds = [
  984122, //forma
  1625, //gravity
  2911, //hychain
  17071, //onchainpoints
  7865, //powerloom
  1996, //sanko
  1514, //story
  660279, //xai
  224235520 //ton
]
